<template>
  <table class="table">
    <tr>
      <th>
        {{ $t('generic.id') }}
      </th>
      <th>
        {{ $t('operators.details.name') }}
      </th>
      <th>
        {{ $t('generic.status') }}
      </th>
    </tr>
    <tr v-for="item in data" :key="item.id">
      <td>{{ item.id }}</td>
      <td>{{ item.name }}</td>
      <td>{{ item.status }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "AssignedOperatorsTable",
  props: {
    data: {
      type: [Array], // Sometimes permissions can be as object(when comes from user), sometimes as array (when comes from role).
      required: true,
    }
  },
  methods: {
    fromObject: function (details) {
      let out = []
      for (const prop in details) {
        const perms = details[prop]
        let p = {
          resource: prop,
          read: perms.includes("read"),
          create: perms.includes("create"),
          update: perms.includes("update"),
          delete: perms.includes("delete"),
        }

        out.push(p)
      }
      return out
    },
    fromArray: function (details) {
      let tmp = {}
      let out = []
      details.forEach(function (entry) {
        let p = tmp[entry.resource]
        if (!p) {
          p = {
            resource: entry.resource,
            read: false,
            create: false,
            update: false,
            delete: false,
          }
          tmp[entry.resource] = p
          out.push(p)
        }

        switch (entry.action) {
          case 'read':
            p.read = true;
            break
          case 'create':
            p.create = true;
            break
          case 'update':
            p.update = true;
            break
          case 'delete':
            p.delete = true;
            break
        }
      });

      return out
    }
  }
}
</script>

<style scoped>
.el-table th {
  background-color: transparent !important;
}
</style>
